<template>
  <div>
  <app-header
      :title="$t('PromotionCode.verification.title')"
      @on-click="goBack"
  ></app-header>
  <div>
  <div v-if='value' class="title">{{$t('PromotionCode.verification.minititle')}}</div>
  <div class="flex_start input_height">
    <van-field
      :keyup="value=value.replace(/\s+/g,'')"
      v-model="value"
      clearable
      :placeholder="$t('PromotionCode.verification.input')"
    >
    </van-field>
      <img @click="Scan()" width="20" height="20" src="../../../assets/imgs/scan.png" v-if="Module_Scan"/>
  </div>
  </div>
  
  <div class="tip">{{$t('PromotionCode.verification.explain')}}</div>
  <div class="flex_center">
  <van-button  @click="showPopup" :class="value?'btn':'btn_display'" round type="info" size="normal">{{$t('PromotionCode.verification.submit')}}</van-button>
  </div>
<van-popup class="dialog" v-model="show"  round  position="bottom" >
<div class="dialog_content">
<div class="flex_center dialog_title" v-if="!isJap">{{$t('PromotionCode.verification.Inquiry')}} {{getInfo}}{{$i18n.locale ==='ar-AE' ? '؟' : '？'}}</div>
<div class="flex_center dialog_title" v-if="isJap">{{getInfo}} {{$t('PromotionCode.verification.Inquiry')}}</div>
<div class="btn_group">
  <van-button class="dialog_bt1" @click="show=false" type="default">{{$t('PromotionCode.verification.cancel')}}</van-button>
  <van-button class="dialog_bt2" @click="confirmBtn" type="default">{{$t('PromotionCode.verification.exchange')}}</van-button>
</div>
</div>

</van-popup>
  </div>
</template>

<script>
import { Toast } from "vant";
import cookie from '../../../utils/cookie'
import checkProjectConfig from '@/lib/checkProjectConfig';

export default {
  components:{
      vanToast:Toast
  },
  data(){
    return{
      value:'',
      getInfo:'',
      show: false,
      isJap:false
    }
  },
  mounted() {
      // 注册scanQRValue方法，接收扫描结果
      window.dsBridge.register('scanQRValue',(val) => {
          let datas =  window.atob(val.split("code=")[1])
          this.value = datas
      }); 
  },
  computed: {
      Module_Scan:function(){
          return checkProjectConfig.setAppThat(this).checkValue("Module_Scan",false);
      }
  },
  methods: {   
   // 调启摄像头扫码
   Scan(){
      window.dsBridge.call('startScanQR');  
   },
   // 弹窗确认
   showPopup(){
    if(cookie.get('langType')==='ja-JP'){
        this.isJap =true
    }else {
        this.isJap =false
    }
    if(this.value){
       this.$http.post({
          url: '/bss/app/topup/CheckVoucherResult',
          data: {
              voucherCode:this.value,
          }
          }).then(res => {
          if(res.data) {
              if(res.data.topupCodeType === 'SALESPRODUCT'){
                this.getInfo = res.data.goodsName
                this.show= true
              }else {
               Toast(this.$t('PromotionCode.verification.ErrorCode'));
              }
          }
      }).catch(err => {   
         Toast(this.$t('PromotionCode.verification.ErrorCode'))                 
          // this.$toast(err);
      });
      }
    },
    goBack() {
       this.$router.go(-1);
    },
      // 确认兑换
  async confirmBtn(){
      let _urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
      await this.$http.post({
            url: '/bss/app/topup/TopUpByVoucher',
            data: {
                voucherCode:this.value,
                conversion:false,
                channelType: this.$APP_CONFIG.request.channelType,
                imei:sessionStorage.getItem('Module_Bind_Group') === 'true' ? _urlData?.imei : ''
            }
        }).then(res => {
            if(res.data) {
                   this.$router.push(this.$setRouteQuery({
                     path: `/rechargeSuccess?goods=${res.data.goodsName}`,
                   },this))

                let category = {
                  CXTC: '畅想套餐',
                  LLTC: '流量套餐',
                  ZLTC: '租赁套餐',
                  BYTC: '包月套餐',
                  CZME: '充值面额',
                  SWBY: '三五包月',
                  BTTC: '包天套餐',
                  MBCP: '会员产品',
                }
                // 神策-点击兑换充值码
                this.$sensors.track('WebGetDisCountCode', {
                    voucher_code: this.value,
                    voucher_goods_name: res.data.goodsName,
                    voucher_goods_category:category[res.data.categoryCode],
                    voucher_goods_period: res.data.periodUnit === "DAY" ? +res.data.period : +res.data.period * 30
                });
            }
        }).catch(err => {                    
            this.$toast(err);
        });
  }
  },
}
</script>
<style type="text/css">
.input_height .van-field__control {
  height: 32px;
}
</style>
<style scoped lang="less">
  .dialog_title {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: rgba(0,0,0,0.87);
    letter-spacing: 0;
    text-align: center;
    line-height: 20px;
  }
  .btn_group{
    width: 100%;
    background-color: #F8F8F8 ;
  }
  .dialog_bt1{
    width:50%;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #333333;
    text-align: center;
    line-height: 16px;
  }
  .dialog_bt2{
    width:50%;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #6BBC46;
    text-align: center;
    line-height: 16px;
  }

.dialog_content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
.dialog_button{
  display: flex;
  background-color: #E0E0E0;

}
.dialog{
  height: 30%;
  width:100%
}

.flex_start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 20px;
}

.btn{
  width:91.1%;
  height:40px;
  background: #6BBC46;
  border-color: #6BBC46;
}

.btn_display{
  width:91.1%;
  height:40px;
  background: #CCCCCC;
  border-color: #CCCCCC;
}

.tip{
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #999999;
  letter-spacing: 0;
  line-height: 20px;
  margin-left: 5%;
  margin-top: 4%;
  margin-right: 6px;
}

.flex_center{
  display: flex;
  justify-content: center;
  margin-top: 80px;
}
.iconScan{
  size:50px;
  color: red;
}
.title{
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0;
  line-height: 12px;
  margin-left: 5%;
  margin-top: 10px;
}

html[dir="rtl"] {
  .tip {
    margin-left: 6px;
    margin-right: 5%;
  }
  .title {
    margin-left: 0;
    margin-right: 5%;
  }
  .input_height {
    ::v-deep .van-field__control {
      text-align: right;
    }
  }
}
</style>